import { useMemo } from 'react';

import { Text } from '../../ui/Text';
import { canUseShortcuts } from '../../utils/execution-environment';
import { StyledKey, StyledWrapper } from './Shortcut.style';

export type ShortcutProps = {
  value: string;
};

export const Shortcut = ({ value }: ShortcutProps) => {
  const keys = useMemo(() => {
    const isMac = canUseShortcuts ? navigator.userAgent.indexOf('Macintosh') >= 0 : false;

    if (isMac) {
      return value.replace('Control', '⌘').replace('Alt', '⌥').replace('Shift', '⇧').split('+');
    }

    return value.split('+');
  }, [value]);

  return (
    <StyledWrapper>
      {keys.map((key) => (
        <StyledKey key={key}>
          <Text size={'Small'}>{key}</Text>
        </StyledKey>
      ))}
    </StyledWrapper>
  );
};
